export function mapTag(tag) {
  return {
    id: tag.tagId,
    name: tag.tagName,
    isSelected: false,
  };
}
